var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { ArrayMinSize, IsArray, IsDate, IsEnum, IsInt, IsOptional, IsString, IsUUID, Min, ValidateNested, } from 'class-validator';
import { SlotSearchStrategy } from '../enums/slot-search-strategy.enum.js';
import { BookedPlanSlotDto } from './booked-plan-slot.dto.js';
import { FixedSlotDto } from './fixed-slot.dto.js';
import { PatientAvailabilityDto } from './patient-availability.dto.js';
import { SchedulingConstraintsDto } from './scheduling-constraints.dto.js';
import { TreatmentConstraintDto } from './treatment-constraint.dto.js';
export class FindEarliestSlotsRequestDto {
    officeLocationId;
    searchFrom;
    n;
    treatmentConstraints;
    schedulingConstraints;
    patientAvailability;
    therapistId;
    roomId;
    /**
     * Objective the slot search optimises for (PRD #928 / RS-006). Omitted ==
     * `PREFER_EARLIEST` (the pre-strategy behaviour). The continuity objective
     * (`PREFER_ONE_THERAPIST`) is wired through here in RS-006 and implemented in
     * RS-007 (#936); before #936 lands the backend treats both values as
     * `PREFER_EARLIEST` so the toggle is non-erroring and the field is forward
     * compatible.
     */
    strategy;
    /**
     * Appointments already placed in the planning (#1937): the step-1 appointment and
     * entries changed by hand. The slot finder proposes only the rest around
     * them — see {@link FixedSlotDto} for how each one counts.
     */
    fixedSlots;
    /**
     * The Verordnung's appointments that are already booked (#1937): each fills
     * its treatment's week of the weekly frequency. See {@link BookedPlanSlotDto}.
     */
    bookedPlanSlots;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], FindEarliestSlotsRequestDto.prototype, "officeLocationId", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], FindEarliestSlotsRequestDto.prototype, "searchFrom", void 0);
__decorate([
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], FindEarliestSlotsRequestDto.prototype, "n", void 0);
__decorate([
    IsArray(),
    ArrayMinSize(1),
    ValidateNested({ each: true }),
    Type(() => TreatmentConstraintDto),
    __metadata("design:type", Array)
], FindEarliestSlotsRequestDto.prototype, "treatmentConstraints", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => SchedulingConstraintsDto),
    __metadata("design:type", SchedulingConstraintsDto)
], FindEarliestSlotsRequestDto.prototype, "schedulingConstraints", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => PatientAvailabilityDto),
    __metadata("design:type", PatientAvailabilityDto)
], FindEarliestSlotsRequestDto.prototype, "patientAvailability", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], FindEarliestSlotsRequestDto.prototype, "therapistId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FindEarliestSlotsRequestDto.prototype, "roomId", void 0);
__decorate([
    IsOptional(),
    IsEnum(SlotSearchStrategy),
    __metadata("design:type", String)
], FindEarliestSlotsRequestDto.prototype, "strategy", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FixedSlotDto),
    __metadata("design:type", Array)
], FindEarliestSlotsRequestDto.prototype, "fixedSlots", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => BookedPlanSlotDto),
    __metadata("design:type", Array)
], FindEarliestSlotsRequestDto.prototype, "bookedPlanSlots", void 0);
//# sourceMappingURL=find-earliest-slots-request.dto.js.map